// extracted by mini-css-extract-plugin
module.exports = {"popup":"style_popup__2HYqS","title":"style_title__1yFal","text":"style_text__3mW1i"};